<template>
<div class="main manage-products">
	<div class="list-view">

		<div class="sub-header">
			<div class="input-with-control">
				<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="doSearch()" v-focus>
				<div class="button action input-go" @click="doSearch()"><i class="fas fa-search"></i></div>
			</div>
			<div class="controls">
				<pagination :paging="paging" @updatePage="goToPage"></pagination>
			</div>
		</div>

		<div class="filters">
			<div class="title">Distributors...</div>
			<div :class="['filter-list-button-large', filters.distributor_code == 'RSR'? 'active' : '']" @click="toggleDistributor('RSR')">
				<div class="label">RSR</div>
			</div>
			<div :class="['filter-list-button-large', filters.distributor_code == 'SS'? 'active' : '']" @click="toggleDistributor('SS')">
				<div class="label">Sports South</div>
			</div>
			<div :class="['filter-list-button-large', filters.distributor_code == 'LIP'? 'active' : '']" @click="toggleDistributor('LIP')">
				<div class="label">Lipsey's</div>
			</div>
			<div :class="['filter-list-button-large', filters.distributor_code == 'ZAN'? 'active' : '']" @click="toggleDistributor('ZAN')">
				<div class="label">Zanders</div>
			</div>
			<div :class="['filter-list-button-large', filters.distributor_code == 'DAV'? 'active' : '']" @click="toggleDistributor('DAV')">
				<div class="label">Davidsons</div>
			</div>

			<div class="divider"></div>

			<div class="title">Translation tables...</div>
			<div :class="['filter-list-button-large', filters.translation_table == 'CATEGORIES'? 'active' : '']" @click="toggleSettings('CATEGORIES')">
				<div class="label">Categories</div>
			</div>
			<div :class="['filter-list-button-large', filters.translation_table == 'MANUFACTURERS'? 'active' : '']" @click="toggleSettings('MANUFACTURERS')">
				<div class="label">Manufacturers</div>
			</div>
			<div :class="['filter-list-button-large', filters.translation_table == 'CALIBERS'? 'active' : '']" @click="toggleSettings('CALIBERS')">
				<div class="label">Calibers</div>
			</div>
			<div :class="['filter-list-button-large', filters.translation_table == 'DESCRIPTORS'? 'active' : '']" @click="toggleSettings('DESCRIPTORS')">
				<div class="label">Descriptors</div>
			</div>

			<div :class="['button',  hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters()">Clear Filters</div>

		</div>

		<div v-if="!showDetail" class="list">
			<div v-if="list.length == 0" class="empty-list">
				Search for a product or<br>select a distributor or translation table to manage.
			</div>

		    <table v-else class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list" width="33"></th>
						<th clsas="list left">Product</th>
						<th class="list left">Distributor</th>
						<th class="list left">Item Number</th>
						<th class="list right">Available</th>
						<th class="list right">Cost</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" class="clickable-list-item">
						<td class="list tiny-image center" width="33" @click="getDetail(item)"><img :src="item.image_src"></td>
						<td class="list left" @click="getDetail(item)">{{ item.description }}<div class="meta"><label>ID: </label>{{ item.product_id }} <label>UPC: </label>{{ item.upc }}</div></td>
						<td class="list left" @click="getDetail(item)">{{ item.distributor_code }}</td>
						<td class="list left" @click="getDetail(item)">{{ item.item_number }}</td>
						<td class="list right" @click="getDetail(item)">{{ item.available }}</td>
						<td class="list right" @click="getDetail(item)">{{ item.cost }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-if="showDetail" class="detail product-detail">
			detail
		</div>

	</div>
</div>
</template>

<script>
import Loading from '@/components/Loading.vue'
export default {
	name: 'distributor-translations',
	props: ['product_id'],
    components: {
        'loading': Loading
    },
	data() {
		return {
			loading: false,
			distributorSet: '',
			settingSet: '',
			filters: {},
			list: [],
			paging: {},
			showDetail: false
		}
	},
	created() {
        if (!this.getAdministratorFlag) {
            this.$router.push('/')
        }
		this.clearFilters()
	},
    computed: {
		hasFilters() {
			for (const [key, value] of Object.entries(this.filters)) {
				if (['distributor_code', 'search_term', 'department_id', 'category_id', 'manufacturer_id', 'distributor_code', 'translation_table'].includes(key) && value) {
					return true
				}
			}
			return false
		}
    },
	watch: {
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				owner: 'distributor',
				distributor_code: '',
				translation_table: '',
				search_term: '',
				department_id: '',
				category_id: '',
				manufacturer_id: '',
				image_size: 'tiny'
			}
			this.list = []
			this.paging = {}
			this.showDetail = false
		},
		doSearch() {
			this.list = []
			this.paging = {}
			this.showDetail = false
			if (this.loading || (!this.filters.search_term && !this.filters.distributor_code)) { return }
            this.loading = true
			this.apiCall({ destination: 'get_list_distributor_products', data: this.filters }).then(obj => {
                this.loading = false
				this.list = obj.list
				this.paging = obj.paging
				if (this.list.length == 1) {
					//this.getDetail(this.list[0])
				}
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.doSearch()
		},
		toggleDistributor(which) {
			if (which == this.filters.distributor_code) {
				this.filters.distributor_code = ''
			} else {
				this.filters.distributor_code = which
			}
			this.doSearch()
		},
		toggleSettings(which) {
			if (which == this.filters.translation_table) {
				this.filters.translation_table = ''
			} else {
				this.filters.translation_table = which
			}
		}
	}
}
</script>
